import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\UpdateSignerPersonForSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/UpdateSignerPersonForSignature.php
* @route '/api/electronic-signature/update-signer-person/{electronicSigner}'
*/
const UpdateSignerPersonForSignature = (args: { electronicSigner: string | number | { id: string | number } } | [electronicSigner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateSignerPersonForSignature.url(args, options),
    method: 'post',
})

UpdateSignerPersonForSignature.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/update-signer-person/{electronicSigner}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\UpdateSignerPersonForSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/UpdateSignerPersonForSignature.php
* @route '/api/electronic-signature/update-signer-person/{electronicSigner}'
*/
UpdateSignerPersonForSignature.url = (args: { electronicSigner: string | number | { id: string | number } } | [electronicSigner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSigner: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSigner: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSigner: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSigner: typeof args.electronicSigner === 'object'
        ? args.electronicSigner.id
        : args.electronicSigner,
    }

    return UpdateSignerPersonForSignature.definition.url
            .replace('{electronicSigner}', parsedArgs.electronicSigner.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\UpdateSignerPersonForSignature::__invoke
* @see app/Http/Controllers/ElectronicSignature/UpdateSignerPersonForSignature.php
* @route '/api/electronic-signature/update-signer-person/{electronicSigner}'
*/
UpdateSignerPersonForSignature.post = (args: { electronicSigner: string | number | { id: string | number } } | [electronicSigner: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateSignerPersonForSignature.url(args, options),
    method: 'post',
})

export default UpdateSignerPersonForSignature